module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA7ElEQVRYR+2WvQ0CMRSDbVo2YAkaGkoqJETPBogaFoASsQEDMAcVQ7AIpVFOCj9RTrniXYJErj7Fn15s5xGFPxbWRwX4moCkNYBRhmu5kLw7nRBAGcSdxJXkLAawAbDqGeJBcuE1qgnrBJITkLR00SR5dsYximo8hp/ulzQEcACwa+JCNrCSLKIaj6EHkDQHcAQwfsXlDWBRVq1FNABwArANu8BPwLojwia8AZjGRP4GoOwVFDfhz8QwAHFFNCG5z1pE1nFrOy9ZxX2DVICwCcuuZEYvXRfbtC6lFi9dF4D0PtDlFIt/agqKT+AJCpBkIW8INwUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu_shousuo_w.png
// module id = rjdS
// module chunks = 171